/* import __COLOCATED_TEMPLATE__ from './phone-handover-goodbye-message.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import Component from '@glimmer/component';

interface Args {
  form: $TSFixMe;
  value?: string;
  placeholder?: string;
  onUpdate: (value: string) => void;
}

export default class PhoneHandoverGoodbyeMessage extends Component<Args> {
  get goodbyeMessage(): string | undefined {
    return this.args.value;
  }

  set goodbyeMessage(value: string | undefined) {
    if (value !== undefined) {
      this.args.onUpdate(value.trim());
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Operator::Fin::Setup::Sections::NumberConfiguration::PhoneHandover::PhoneHandoverGoodbyeMessage': typeof PhoneHandoverGoodbyeMessage;
  }
}
